import { render, staticRenderFns } from "./WaitView.vue?vue&type=template&id=ce2daf98&scoped=true"
var script = {}
import style0 from "./WaitView.vue?vue&type=style&index=0&id=ce2daf98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2daf98",
  null
  
)

export default component.exports